// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/SellerForm/ChatList/index.less
// module id = 1759
// module chunks = 0